import { LinkModel } from '../../Forms/models/link.model';

export class ImageSettingsModel {
    displaySize: number = null;
    caption: string = null;
    altText: string = null;
    link: LinkModel;

    constructor(apiModel?: any) {
        if (apiModel) {
            // in https://phabricator.agilitypr.internal/D18249, we intentionally set null as default value
            // Thus, here we make it consistent, otherwise, when converting distribution to wire, it may cause unsaved change bug
            this.altText = apiModel.altText ? apiModel.altText : null;
            this.caption = apiModel.caption ? apiModel.caption : null;
            this.displaySize = apiModel.displaySize ? apiModel.displaySize : null;

            if (apiModel.link) {
                this.link = new LinkModel(apiModel.link);
            }
        }
    }

    toApi(): any {
        const api = {
            displaySize: this.displaySize,
            caption: this.caption,
            altText: this.altText,
            link: this.link?.toApi()
        };

        return api;
    }

    clone(): ImageSettingsModel {
        const apiModel = this.toApi();
        const clone = new ImageSettingsModel(apiModel);

        return clone;
    }
}
